<template>
    <div class="main-container">
        <div class="precompilation-page">
            <div class="precompilation-page__left">
                <main-menu></main-menu>
            </div>
            <div class="precompilation-page__right">
                <div class="form--overflow">
                    <div class="form__row">
                        <div class="btns-row__left-btns">
                            <Label class="form__label">
                                <p>This action will recompile static data files for ALL arenas.</p>
                                <p>You should send this request when you did some changes in following sections:</p>
                            </Label>
                            <ul class="section-list">
                                <li>Sorting Games Control</li>
                                <li>Games Versions Control</li>
                                <li>Game Rules</li>
                                <li>Feeds Control</li>
                                <li>Feeds Details</li>
                                <li>Games Meta Data</li>
                            </ul>
                        </div>
                        <div class="btns-row__right-btns">
                            <button
                                v-if="$checkRoles(['Administrator'])"
                                class="ark-btn ark-btn--danger"
                                @click="sendRequest()"
                            >
                                <Loader v-if="isPrecompilationInProgress"></Loader>
                                <span v-else>Send re-compile request</span>
                            </button>
                        </div>
                        <div class="btns-row__right-btns">
                            <button
                                v-if="$checkRoles(['Administrator'])"
                                class="ark-btn ark-btn--danger"
                                @click="sendMetaDataPrecompileRequest()"
                            >
                                <Loader v-if="isMetaDataPrecompilationInProgress"></Loader>
                                <span v-else>Send Meta Data re-compile request</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form">
                    <div v-if="arenas.length" class="arena-data-links-form">
                        <div class="form__row">
                            <FilterInput
                                title="Filter Arenas"
                                :filterList="arenas"
                                v-on:filter="onFilterArenas"
                            ></FilterInput>
                        </div>

                        <div class="form__row">
                            <div class="arenas-list-wrap">
                                <ul class="arena-data-links-list">
                                    <li v-for="(arenaLink, i) in filteredArenas" :key="arenaLink + i">
                                        <a :href="arenaLink" target="_blank">{{ arenaLink }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <InfoModal
            v-if="isPrecompilationRequestSent"
            :msg="'Request to re-compile all arenas data sent successfully.'"
            :onCloseModal="closeInfoModal"
        ></InfoModal>
    </div>
</template>

<script>
import config from '../../config';
import { locales } from '../../constants/locales';
import Loader from '../Loader/Loader.vue';
import { sortAsc } from '../../utils/sorting';
import InfoModal from '../InfoModal/InfoModal.vue';
import FilterInput from '../FilterInput/FilterInput.vue';
import MainMenu from '../MainMenu/MainMenu.vue';

export default {
    components: { MainMenu, Loader, InfoModal, FilterInput },
    name: 'Precompilation',
    props: [],
    data() {
        return {
            arenas: [],
            locales: locales,
            filteredArenas: [],
            isPrecompilationInProgress: false,
            isPrecompilationRequestSent: false,
            isMetaDataPrecompilationInProgress: false,
        };
    },
    methods: {
        closeInfoModal: function () {
            this.isPrecompilationRequestSent = false;
        },
        onFilterArenas: function (arenas) {
            this.filteredArenas = sortAsc(arenas);
        },
        sendMetaDataPrecompileRequest: function () {
            this.isMetaDataPrecompilationInProgress = true;

            let mataDataPrecompilationPromise = this.$http.post(
                `${config.apiUrl}/notification/request-metadata-update`
            );

            Promise.all([mataDataPrecompilationPromise]).then(
                ([response]) => {
                    this.isMetaDataPrecompilationInProgress = false;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        sendRequest: function () {
            this.isPrecompilationInProgress = true;
            this.filteredArenas = [];

            let precompilationPromise = this.$http.post(`${config.apiUrl}/notification/request-recompile-update`);
            let arenasPromise = this.$http.get(`${config.apiUrl}/arena/table-model/list`);

            Promise.all([precompilationPromise, arenasPromise]).then(
                ([arenaTextResponse, arenasResponse]) => {
                    this.arenas = [];

                    this.isPrecompilationInProgress = false;
                    this.fillArenas(arenasResponse.body);
                    this.isPrecompilationRequestSent = true;
                },
                (error) => {
                    console.log(error);
                    this.isPrecompilationInProgress = false;
                }
            );
        },
        fillArenas: function (arenas) {
            arenas.forEach((arena) => {
                this.arenas.push(
                    `https://${config.storageName}.blob.core.windows.net/arenax-index/${arena.domain}/assets/json/arena-data.json`
                );
                this.locales.forEach((locale) => {
                    this.arenas.push(
                        `https://${config.storageName}.blob.core.windows.net/arenax-index/${arena.domain}/assets/json/arena-data_${locale.value}.json`
                    );
                });
            });
            this.filteredArenas = sortAsc(this.arenas);
        },
    },
};
</script>

<style scoped lang="scss" src="./Precompilation.scss"></style>
